import { useContext } from 'react';
import { PmpConfigContext } from '@pmp/contexts';

export const useConfigReady = (): boolean => {
  const { featureToggles } = useContext(PmpConfigContext);

  return !!(featureToggles && Object.keys(featureToggles).length);
};
